import get from 'lodash/get';

export const membersListSelector = state =>
  get(state, 'communities.membersList', []);

export const moderatorsListSelector = state =>
  get(state, 'communities.moderatorsList', []);

export const membersCountSelector = state =>
  get(state, 'communities.communityMembers.meta.membersCount', 0);

export const moderatorsCountSelector = state =>
  get(state, 'communities.communityModerators.meta.moderatorsCount', 0);



// WEBPACK FOOTER //
// ./src/components/Community/About/selectors.js